import React, { useImperativeHandle } from 'react';
import { getUUID } from '../../utils/helpers';
import  Tooltip from './Tooltip';
import ReactTooltip from "react-tooltip";
import { ImgInfo } from '../../svg/reclamo';

const SwitchButtonNR = ({label, 
    value=undefined, onClick=()=>null, 
    si= 'Si', no= 'No'
    , classLabel = '', 
    usetooltip = false,
    tooltipTitle ='',
    tooltipText = '',
    className= ''

}) => {

    var classInput = "sg-input-switch-option-nr "+ {className};

    /**
     * 
     * <label className={classLabel}>{label}</label>
     */
    return (       
         <div className="sg-input-switch">
            
            {usetooltip ==="true" && 
            <div className="label-with-info">
                     <label className={classLabel}>{label}</label>
                        <Tooltip title={tooltipTitle} text={tooltipText} />
                        </div>
               
            }
            
            {usetooltip ===false &&
            <label  className={classLabel}>{label} </label>
            }
            <div className= {classInput}>
              
                <button onClick={e => onClick(true)} type="button" className={value === true?'sg-switch-active-nr':''}>{si}</button>
                <button onClick={e => onClick(false)} type="button" className={value=== false?'sg-switch-active-nr':''}>{no}</button>
                {value === undefined && 
                    <input type="radio" name={label || getUUID()} className="sg-switch-validator-nr" required/>
                }
            </div>
        </div>
    );
}

export default SwitchButtonNR